import React, { PureComponent } from 'react'
import { Link } from "react-router-dom";
import {
  Button,
  Input,
  Form,
  Alert,
  message
} from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
// import '@ant-design/compatible/assets/index.css'
// import 'antd/dist/reset.css'; // untuk v5

// import { faQrcode } from "@fortawesome/free-solid-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Config from '../Config';
import {Helmet} from "react-helmet";

import { connect } from 'react-redux';
import { 
  setConfig, 
  ajaxHandler, 
  ajaxViewHandler 
} from "../store/actions";

// import axios from 'axios';
import Cookies from 'js-cookie';
// import QRCode from 'qrcode.react';

import 'antd/dist/antd.css';
import '../assets/loginStyle.css';
import { v4 as uuidv4 } from 'uuid';



const generateDeviceId = () => {
  return localStorage.getItem("device_id") || uuidv4();
};

// Ekstrak pesan error login menjadi string, agar aman dipakai sebagai
// children React (Antd Alert akan crash/blank putih jika diberi object mentah).
const extractLoginErrorMessage = (responseMsg, responseCode) => {
  if (responseCode === 401) {
    return "Login Gagal, username/password salah";
  }
  if (typeof responseMsg === 'string') {
    return responseMsg;
  }
  if (responseMsg && typeof responseMsg === 'object') {
    if (responseMsg.access !== undefined) {
      return responseMsg.access;
    }
    if (Array.isArray(responseMsg.non_field_errors)) {
      return responseMsg.non_field_errors.join(' ');
    }
    if (typeof responseMsg.detail === 'string') {
      return responseMsg.detail;
    }
    // DRF membungkus ValidationError(dict) jadi list per-key lewat
    // as_serializer_error(), mis. {"code": ["device_conflict"], "detail": ["..."]}
    if (Array.isArray(responseMsg.detail)) {
      return responseMsg.detail.join(' ');
    }
    const flattened = Object.values(responseMsg).flat().filter(v => typeof v === 'string');
    if (flattened.length > 0) {
      return flattened.join(' ');
    }
  }
  return "Login gagal, silakan coba lagi.";
};

// Deteksi error khusus "device lock dipegang device lain" (lihat
// be/samsat/views.py CustomTokenObtainPairSerializer.validate) - dipakai
// utk menampilkan tombol "Paksa Login". code bisa berupa string polos atau
// list satu-elemen tergantung jalur DRF yang memprosesnya.
const isDeviceConflictError = (responseMsg) => {
  const code = responseMsg && responseMsg.code;
  return Array.isArray(code) ? code.includes('device_conflict') : code === 'device_conflict';
};

// Simpan UUID di localStorage
localStorage.setItem("device_id", generateDeviceId());

// console.log("Device ID:", generateDeviceId());


const configClass = {
  apiUrl: {
    cekLogin: "api/token/"
  }
}

class AuthLayout extends PureComponent {
  config;
  timeoutGetQr;
  timeOutPushQr;

  constructor(props){
    super(props);
    this.config = new Config();
    this.state = {
      msg: '',
      loading: false,
      loadingRedirect: false,
      logo: this.config.get_site_info().logo_landscape,
      websock:this.config.get_web_socket(),
      password: '',
      deviceConflict: false,
    };
    this.reconnectAttempts = 0;
    this.connectWebSocket = this.connectWebSocket.bind(this);
  }

  componentDidMount(){
    const authCookie = Cookies.get(this.config.get_cookie_name());
    if (authCookie) {
      this.props.history.replace('/admin/index');
    }
  }

  handleSubmit = (values) => {
    // values.preventDefault();
    var params = new FormData();
    params.append("username", values.username);
    params.append("password", values.password);
    params.append("device_id", generateDeviceId());
    this.setState({
      username: values.username,
      password: values.password,
      device_id: generateDeviceId(),
      deviceConflict: false,
    });
    // this.postLogin(params);
      //   socket.onopen = () => {
      //   console.log("WebSocket Connected");
      // };
    this.connectWebSocket(params);
    // this.postLogin(params);
  }

  // Dipanggil saat user klik "Paksa Login" setelah menerima error
  // device_conflict - username/password sudah tersimpan dari submit
  // sebelumnya (dan sudah TERBUKTI benar, itu sebabnya error-nya device
  // conflict bukan password salah), tinggal kirim ulang dgn force_login=1.
  handleForceLogin = () => {
    var params = new FormData();
    params.append("username", this.state.username);
    params.append("password", this.state.password);
    params.append("device_id", this.state.device_id || generateDeviceId());
    params.append("force_login", "1");
    this.setState({ deviceConflict: false });
    this.connectWebSocket(params);
  }

  // doLoginPrototype(){
  //   Cookies.set(this.config.get_cookie_name(), 'Bearer testing', { expires: 1 });
  //   this.setState({
  //         loading: false,
  //         loadingRedirect: true
  //   });
  //   setTimeout(() => {
  //         this.props.setConfig({
  //           isLogin: true
  //         });
  //   }, 3000);
  // }

  async connectWebSocket(params) {    
    // const socket = new WebSocket(`ws://localhost:8000/ws/device/${userId}/?device_id=${deviceId}`);

    // ✅ Cek apakah WebSocket sudah aktif
    if (this.socket && this.socket.readyState == WebSocket.OPEN) {
      console.warn("WebSocket sudah aktif. Reconnect dibatalkan.");
      this.postLogin(params);
      return;
    }

    // ✅ Optional: jika socket masih di CONNECTING atau CLOSING, bisa ditutup dulu
    if (this.socket && this.socket.readyState != WebSocket.CLOSED) {
      this.socket.close();
      this.socket = null;
    }

    // 🌐 Inisialisasi koneksi baru
    this.socket = new WebSocket(this.config.get_web_socket() + `/ws/login/${this.state.username}/?device_id=${this.state.device_id}`);

    this.socket.onopen = () => {
      // message.success({ content: `Server terhubung!`, duration: 5, key: 'toast' });
      this.reconnectAttempts = 0;
      if (this.socket.readyState == WebSocket.OPEN) {
        this.postLogin(params);
			}
    };

    this.socket.onmessage = (event) => {
      const data = JSON.parse(event.data);
      if (data.status == 3) {
        message.success({ content: `${data.message}`, duration: 3, key: 'toast'});
      }
      else if(data.status == "login_gagal") {
        message.error({ content: `${data.message}`, duration: 8, key: 'toast'});
        this.socket.close(1000, 'Logout sent');
      }
    };

    this.socket.onclose = (event) => {
        // console.warn("Koneksi WebSocket ditutup!", event);
        // Coba reconnect setelah 3 detik jika koneksi tidak ditutup secara bersih
        if (!event.wasClean) {
          let delay = Math.min(30000, Math.pow(2, this.reconnectAttempts) * 1000); // Maksimum 30 detik
          message.error({ content: `Koneksi putus, menghubungkan ulang dalam ${delay / 1000} detik...`, duration: 5, key: 'toast' });
          setTimeout(() => {
            this.reconnectAttempts++;
            this.connectWebSocket(this.state.username);
          }, delay);
        };
    };

    this.socket.onerror = (error) => {
      message.error({ content: `Terjadi kesalahan pada WebSocket: ${error}`, duration: 5, key: 'toast' });
    };

    return () => this.socket.close();
  }

  sendWhenReady(socket, message) {
    if (socket.readyState == WebSocket.OPEN) {
      socket.send(JSON.stringify(message));
    } else {
      socket.addEventListener("open", function handler() {
        socket.send(JSON.stringify(message));
        socket.removeEventListener("open", handler); // Hapus listener sekali pakai
      });
    }
  }


  async postLogin(datas) {
    //message.loading({ content: 'Memproses...', duration: 2, key: 'toast' });
    this.setState({
        loading: true
    });

    
    // this.connectWebSocket(this.state.username);
    this.props.ajaxHandler('post', configClass.apiUrl.cekLogin, datas, true, true)
    .then(() =>{
      this.setState({
        loading: false
      });
      if(this.props.isSuccess){
        // Dihitung di sini (bukan sekali di scope module) - kalau tab dibiarkan
        // terbuka lebih dari 30 menit sebelum sesi habis dan user login ulang,
        // nilai yang dihitung sekali di awal sudah jadi tanggal masa lalu,
        // membuat Cookies.set gagal tersimpan (dianggap cookie kedaluwarsa).
        // 30 menit - selaras dengan store.js (silent-refresh), IDLE_LOGOUT_MS
        // (AdminLayout.jsx), dan IDLE_TIMEOUT_SECONDS (backend authentication.py).
        const inExpired = new Date(new Date().getTime() + 30 * 60 * 1000);
        Cookies.set(this.config.get_cookie_name(), 'Bearer '+this.props.responseMsg.access, { expires: inExpired });
        Cookies.set(this.config.get_cookie_name() + "_username", this.config.get_cookie_name()+"_"+this.state.username, { expires: inExpired })
        Cookies.set(this.config.get_cookie_name() + "_expired", this.config.get_cookie_name()+"_expired", { expires: inExpired })
        // Refresh token disimpan terpisah (umur 1 hari, sesuai REFRESH_TOKEN_LIFETIME
        // backend) - dipakai LayananRoute.js buat perpanjang access token diam-diam
        // selama masih ada aktivitas, tanpa perlu login ulang.
        if (this.props.responseMsg.refresh) {
          Cookies.set(this.config.get_cookie_name() + "_refresh", this.props.responseMsg.refresh, { expires: 1 });
        }
        localStorage.setItem("logout", false);

        this.setState({
          loading: false,
          loadingRedirect: true
        });
        
        // this.connectWebSocket(this.state.username);
        this.sendWhenReady(this.socket, {
          type: "login",
          username: this.state.username,
          // password: this.state.password,
          device_id: this.state.device_id,
          status: "sukses",
        });


        // if (this.socket && this.socket.readyState == WebSocket.OPEN) {
        


        window.location.replace("/admin");
      }else{
        this.sendWhenReady(this.socket, {
          type: "login",
          username: this.state.username,
          // password: this.state.password,
          device_id: this.state.device_id,
          status: "gagal"
        });
        localStorage.removeItem("logout");
        localStorage.removeItem("isbypass");


        this.setState({
          msg: extractLoginErrorMessage(this.props.responseMsg, this.props.responseCode),
          deviceConflict: isDeviceConflictError(this.props.responseMsg),
        });
      }
    }).catch((response) => {
      console.log('gagal_post', response);
      this.setState({
          loading: false
        });
      message.error({ content: 'kesalahan pengiriman data, code: '+response.responseCode+' coba lagi', duration: 2, key: 'toast' });
    });
  }

  render() {
    return (
      <div className="login-root">
        <Helmet>
          <title>LOGIN | {this.config.get_site_info().name}</title>
        </Helmet>

        {this.state.loadingRedirect ? (
          <div className="splash">
            <div className="eclipse"></div>
            <div className="logo-splash">
              <img alt="logo" src={this.state.logo} height="120" style={{ marginBottom: 32 }} />
              <br />
              <img src={process.env.PUBLIC_URL + "/loading.gif"} alt="loading" width="48"
                style={{ filter: 'brightness(0) invert(1)', opacity: 0.85 }} />
            </div>
            <div className="eclipse-bawah"></div>
          </div>
        ) : (
          <div className="login-page">
            <div className="login-bg-deco login-bg-deco-1"></div>
            <div className="login-bg-deco login-bg-deco-2"></div>
            <div className="login-bg-deco login-bg-deco-3"></div>

            <div className="login-card">
              <div className="login-logo-area">
                <Link to="/">
                  <img alt="logo" src={this.state.logo} />
                </Link>
              </div>

              <div className="login-header">
                <h2>Selamat Datang</h2>
                <p>Masuk untuk mengakses sistem e-SAMSAT</p>
              </div>

              {this.state.msg !== '' && (
                <Alert
                  className="login-alert"
                  message={this.state.msg}
                  type="error"
                  showIcon
                  closable
                />
              )}

              {this.state.deviceConflict && (
                <Button
                  className="btn-login-new"
                  block
                  size="large"
                  danger
                  loading={this.state.loading}
                  onClick={this.handleForceLogin}
                  style={{ marginBottom: 16 }}
                >
                  Paksa Login di Perangkat Ini
                </Button>
              )}

              <Form
                name="login"
                layout="vertical"
                className="login-form-items"
                onFinish={this.handleSubmit}
              >
                <Form.Item
                  name="username"
                  rules={[{ required: true, message: 'Username harus diisi!' }]}
                >
                  <Input
                    prefix={<UserOutlined />}
                    placeholder="Username"
                    size="large"
                    className="login-form-input"
                    style={{ textTransform: 'none' }}
                  />
                </Form.Item>
                <Form.Item
                  name="password"
                  rules={[{ required: true, message: 'Password harus diisi!' }]}
                >
                  <Input.Password
                    prefix={<LockOutlined />}
                    placeholder="Password"
                    size="large"
                    className="login-form-input"
                    style={{ textTransform: 'none' }}
                  />
                </Form.Item>
                <Form.Item style={{ marginBottom: 0 }}>
                  <Button
                    className="btn-login-new"
                    loading={this.state.loading}
                    htmlType="submit"
                    block
                    size="large"
                  >
                    Masuk ke Sistem
                  </Button>
                </Form.Item>
              </Form>

              <div className="login-card-footer">
                <img src={process.env.PUBLIC_URL + "/samsat-gabung.png"} alt="gbr" height={28} />
                <div className="login-copyright">
                  &copy; {new Date().getFullYear()} {this.config.get_site_info().name}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = function(state) {
  return state.configReducers
}

export default connect(mapStateToProps, 
                        {
                          setConfig,
                          ajaxHandler,
                          ajaxViewHandler
                        }
                  )(AuthLayout);
